import React, { Fragment, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Pagination from '../../common/Pagination';
import {
  checkIfProductHasVariants,
  getItemDefaultBarcode,
  getItemPriceString,
  getItemVariantsString,
  getProductImageUrl,
  getVariantImageUrl,
  getType,
} from '../../../helpers';
import styled from '@emotion/styled';
import { ITEMS_PAGE_TABS, ITEMS_TYPES, ITEMS_BADGES, PRODUCT_BADGES_TYPES } from '../../../config';
import InputWrapper from '../../common/InputWrapper';
import Select from '../../common/Select';
import { useSelector } from 'react-redux';

const Wrapper = styled(`div`)`
  margin: 35px -22px 0;
  position: relative;

  .table-row-wrapper {
    border-top: 1px solid #e3e5e7;
    border-bottom: 1px solid #e3e5e7;
    overflow: hidden;
    margin-bottom: 2px;
  }

  .row-available {
    margin-left: 10px;
    font-size: 12px;
    opacity: 0.8;
  }

  .table-row,
  .variant-row {
    padding: 16px;
    background: white;
    display: flex;

    .right {
      flex-grow: 1;
      max-width: calc(100% - 66px);
    }

    .image-block {
      width: 50px;
      height: 50px;
      object-fit: cover;
      margin-right: 16px;
      border-radius: 4px;
    }

    .table-item-title {
      font-size: 12px;
      margin: 0;
    }

    .variant-toggle-span {
      color: #98a6ad;
      font-size: 11px;
      max-width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .row-footer {
      display: flex;
      height: 20px;
      align-items: flex-end;
      margin-top: 8px;
    }

    .row-price {
      font-size: 12px;
      font-weight: 600;
    }

    .fe-chevron-right,
    .fe-chevron-down,
    .fe-plus,
    .fe-minus {
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      margin: 0 !important;
      color: #7e57c2;
    }

    .chevron-td {
      margin-left: auto;
      position: relative;
      top: 3px;
    }

    .stock {
      margin-left: 15px;
      color: #98a6ad;
      font-size: 11px;
    }

    .footer-quantity-picker {
      margin-left: auto;

      .quantity-control {
        width: 20px;
        height: 20px;
      }
    }
  }

  .variant-row {
    background: #fcfdff;
    padding-left: 15px;
    border-top: 1px solid #e3e5e7;
  }

  .form-search {
    padding: 16px;
    position: relative;

    .show-filter {
      position: absolute;
      right: 20px;
      top: 21px;
    }
  }

  .form-filters {
    padding: 13px 16px 16px;
    margin-top: 16px;
    background: #fcfdfd;
    position: relative;

    .close-button {
      position: absolute;
      width: 30px;
      height: 30px;
      top: 0;
      right: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .float-right {
    width: 100%;
    display: flex;
    justify-content: center;
    background: white;
    margin-top: 100px;

    .pagination {
      margin-left: 0 !important;
    }
  }

  .header {
    position: fixed;
    z-index: 1;
    top: 36px;
    width: 100%;
    display: flex;
    align-items: center;
    background: #fff;
    padding: 0 16px;
    border-bottom: 1px solid #ebebeb;
    height: 40px;

    .updating-button {
      line-height: 1;
      margin-left: auto;
    }
  }

  .new-item {
    position: fixed;
    right: 6%;
    bottom: 10%;
    z-index: 1;
    width: 70px;
    height: 70px;
    border-radius: 50%;
    font-size: 18px;
  }
`;

const ItemsTabsWrapper = styled('div')`
  position: relative;
  width: calc(100% + 10px);
  display: flex;

  &::before,
  &::after {
    content: '';
    position: absolute;
    z-index: 1;
    opacity: 0;
    transition: opacity 0.3s;
    pointer-events: none;
    top: 0;
    bottom: 2px;
    width: 100px;
  }

  &.leftShadowed::before {
    background: linear-gradient(90deg, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0));
    left: 0;
    opacity: 1;
  }

  &.rightShadowed::after {
    background: linear-gradient(90deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));
    opacity: 1;
    right: 0;
  }

  .nav-tabs-container {
    display: flex;
    padding: 0 5px;
    overflow-x: auto;
    font-family: 'Roboto', sans-serif;
    font-size: 12px;
    font-weight: 500;
    color: #93959d;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .nav-tabs-wrapper {
    display: inline-block;
  }

  .nav-tabs-orders {
    display: flex;
    flex-wrap: nowrap;
  }

  .tab-title {
    white-space: nowrap;
  }

  .nav-link {
    padding: 5px 15px 7px;
    position: relative;

    &.active {
      color: #7e57c2;

      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 10px;
        width: calc(100% - 20px);
        height: 2px;
        background: #7e57c2;
      }
    }
  }
`;

const TableRow = (props) => {
  const { item, handleGotoItemPage, currencySymbol, openVariant } = props;

  const hasVariants = checkIfProductHasVariants(item);
  const [show, setShow] = useState(false);

  const handleShowVariant = (evt) => {
    evt.stopPropagation();
    setShow(!show);
  };

  return (
    <div className="table-row-wrapper">
      <div
        className={`table-row ${!item.available ? 'not-available' : ''}`}
        key={item.id}
        onClick={() => handleGotoItemPage(item)}
      >
        <img alt="" className="image-block" src={getProductImageUrl(item, 250)} />
        <div className="right">
          {item.type && item.type !== 'SKU' ? (
            <span className="badge mini-badge" style={ITEMS_BADGES[getType(item)]}>
              {PRODUCT_BADGES_TYPES.find((t) => t.value === getType(item)).label.toLowerCase()}
            </span>
          ) : null}
          <h5 className="table-item-title">{item.shortName}</h5>
          <div className="variant-toggle-span">
            {hasVariants
              ? getItemVariantsString(item.variants.length)
              : item.variants &&
                item.variants.length && (
                  <>
                    {item.variants[0].id}{' '}
                    {item.variants[0].extId ? `(${item.variants[0].extId})` : null}
                  </>
                )}
          </div>
          <div className="row-footer">
            <div style={{ whiteSpace: `nowrap` }} className="row-price">
              {getItemPriceString(item, null, currencySymbol)}
            </div>
            {!hasVariants && (
              <div className="row-available">
                <>Остаток: </>
                {item.variants[0]?.stock && item.variants[0].stock.length ? (
                  <Fragment>
                    {item.variants[0].stock.reduce((a, c) => {
                      a += c.stockAvailable;
                      return a;
                    }, 0)}
                  </Fragment>
                ) : (
                  0
                )}
              </div>
            )}
            {hasVariants ? (
              <div className="chevron-td">
                <i className="fe-chevron-down" onClick={handleShowVariant} />
              </div>
            ) : null}
          </div>
        </div>
      </div>
      {show
        ? item.variants?.map((variant) => (
            <div
              key={variant.id}
              className="variant-row"
              onClick={() => openVariant(item, variant.id)}
            >
              <img
                className="image-block"
                src={getVariantImageUrl(variant, 100)}
                alt={item.shortName}
              />
              <div className="right">
                <div className="table-item-title">
                  {`${item.shortName} ${variant.optionsUsed?.map((o) => o.stringValue).join(' ')}`}
                </div>
                <div className="variant-toggle-span">
                  {variant.id} {variant.extId ? `(${variant.extId})` : null}
                  <br />
                  {variant.article}
                  <br />
                  {getItemDefaultBarcode(variant) ? getItemDefaultBarcode(variant).value : null}
                </div>
                <div className="row-footer">
                  <div style={{ whiteSpace: `nowrap` }} className="row-price">
                    {getItemPriceString(item, variant, currencySymbol)}
                  </div>

                  <div className="row-available">
                    <>Остаток: </>
                    {variant.stock && variant.stock.length ? (
                      <Fragment>
                        {variant.stock.reduce((a, c) => {
                          a += c.stockAvailable;
                          return a;
                        }, 0)}
                      </Fragment>
                    ) : (
                      0
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))
        : null}
    </div>
  );
};

const MobileCustomMenu = (props) => {
  const { handleOpenTab, activeTab } = props;

  const handleScroll = (evt) => {
    const tabsWrapper = evt.target;
    if (tabsWrapper.scrollLeft) tabsWrapper.parentElement.classList.add(`leftShadowed`);
    else tabsWrapper.parentElement.classList.remove(`leftShadowed`);

    if (evt.target.scrollLeft - tabsWrapper.scrollWidth + tabsWrapper.offsetWidth)
      tabsWrapper.parentElement.classList.add(`rightShadowed`);
    else tabsWrapper.parentElement.classList.remove(`rightShadowed`);
  };

  return (
    <ItemsTabsWrapper onScroll={handleScroll} className="rightShadowed">
      <div className="nav-tabs-container">
        <div className="nav-tabs-wrapper">
          <ul className="nav nav-tabs-orders">
            {ITEMS_PAGE_TABS.map((tab) => (
              <li className="nav-item" key={tab.id}>
                <div
                  data-toggle="tab"
                  aria-expanded="true"
                  className={`nav-link ${activeTab === tab.id ? 'active' : ''}`}
                  onClick={() => handleOpenTab(tab)}
                >
                  <div className="d-flex flex-row">
                    <div className="tab-title">{tab.title}</div>
                  </div>
                </div>
                <div className={`nav-link-after ${activeTab === tab.id ? `active` : ``}`} />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </ItemsTabsWrapper>
  );
};

const MobileLayout = (props) => {
  const {
    archiveMode,
    data,
    totalItems,
    search,
    barcode,
    currencySymbol,
    handleSearch,
    handleSearchByBarcode,
    handleDeliveryModal,
    handleGotoItemPage,
    openVariant,
    state,
    handlePageSelect,
    setState,
    handleToggleArchive,
    setMobileCustomMenu,
    activeTab,
    handleOpenTab,
    types,
    handleTypeItems,
    urlSearchStr,
    skuSets,
  } = props;

  const [showFilter, setShowFilter] = useState(false);

  useEffect(() => {
    setMobileCustomMenu(<MobileCustomMenu handleOpenTab={handleOpenTab} activeTab={activeTab} />);
    return () => {
      setMobileCustomMenu(null);
    };
  }, [activeTab, activeTab]);

  return (
    <Wrapper>
      <button
        type="button"
        className="btn btn-danger waves-effect waves-light new-item"
        onClick={() =>
          handleGotoItemPage(
            null,
            activeTab == 'all' || activeTab == 'items'
              ? 'SKU'
              : activeTab == 'sets'
              ? 'PHYSICAL_SET'
              : 'BUNDLE',
          )
        }
      >
        <i className="fe-plus" />
      </button>
      <div className="form-search">
        <input
          className="form-control search-input"
          type="text"
          placeholder="Поиск"
          value={search}
          onChange={(e) => handleSearch(e.target.value)}
        />
        <button
          type="button"
          className="btn btn-primary btn-xs waves-effect waves-light show-filter"
          onClick={() => setShowFilter(true)}
        >
          <i className="fe-sliders" />
        </button>
        {showFilter ? (
          <>
            <div className="form-filters">
              <div className="close-button" onClick={() => setShowFilter(false)}>
                <i className="fe-x" />
              </div>
              <div className="form-group">
                <InputWrapper
                  className="form-control"
                  type="text"
                  label="Штрихкод"
                  placeholder="Штрихкод"
                  value={barcode}
                  onChange={(e) => handleSearchByBarcode(e.target.value)}
                  icon="mdi mdi-barcode-scan"
                />
              </div>

              {activeTab === 'all' && (
                <div className="form-group">
                  <Select
                    label="Тип товаров"
                    id="types"
                    options={ITEMS_TYPES}
                    value={types}
                    onChange={(value) => handleTypeItems(value)}
                    isMulti
                  />
                </div>
              )}
              <div className="form-group mr-2 mt-2 mb-2">
                <Link className="btn btn-light mr-2" to="/imports">
                  <i className="fe-arrow-up" /> Импорт
                </Link>
                <button className="btn btn-light" onClick={() => handleDeliveryModal()}>
                  <i className="fe-arrow-down" /> Экспорт
                </button>
              </div>
              <div className="mt-2">
                <div className="btn-group">
                  <button
                    type="button"
                    className="btn btn-light"
                    onClick={() => setState({ tableMode: true })}
                  >
                    <i className="fe-list" />
                  </button>
                  <button
                    type="button"
                    className="btn btn-light"
                    onClick={() => setState({ tableMode: false })}
                  >
                    <i className="fe-grid" />
                  </button>
                </div>
                <button
                  type="button"
                  className={`btn ml-2 ${archiveMode ? 'btn-secondary' : 'btn-light'}`}
                  onClick={() => handleToggleArchive()}
                >
                  <i className="fe-archive" />
                </button>
              </div>
            </div>
          </>
        ) : null}
      </div>

      {data.map((item) => (
        <TableRow
          item={item}
          handleGotoItemPage={handleGotoItemPage}
          currencySymbol={currencySymbol}
          openVariant={openVariant}
        />
      ))}
      <Pagination
        appStateKey="productsPage"
        total={totalItems}
        currentPage={Number(state.page)}
        onPageSelect={(pageIndex) => handlePageSelect(pageIndex)}
      />
    </Wrapper>
  );
};

export default MobileLayout;
